import {getPageFromPath} from '../../common/utils';

export enum RumErrorLevel {
    Info = 'info',
    Debug = 'debug',
    Warn = 'warn',
    Error = 'error',
    Fatal = 'fatal',
}

export interface RumError {
    level?: RumErrorLevel;
    message?: string;
    type?: string;
    page?: string;
    additional?: Record<string, unknown>;
    error?: unknown;
}

function isRumAvailable() {
    return window.Ya && window.Ya.Rum;
}

export function rumSendFrameworkInitialized() {
    if (!isRumAvailable()) {
        return;
    }

    const FRAMEWORK_INITIALIZED = '3036';
    window.Ya.Rum.sendTimeMark(FRAMEWORK_INITIALIZED);
}

export function rumFirstMeaningfulPaintInit() {
    if (!isRumAvailable()) {
        return;
    }

    const HERO_ELEMENT = '2876';
    const mainContentElement = '.app-shell';
    window.Ya.Rum.observeDOMNode(HERO_ELEMENT, mainContentElement);
}

export function setRumPage(page: string) {
    if (!isRumAvailable()) {
        return;
    }

    window.Ya.Rum.setVars({'-page': page});
    window.Ya.Rum.updateErrors({page});
}

export function sendRumError(rumError: RumError) {
    const {
        error,
        level = RumErrorLevel.Error,
        page = getPageFromPath(window.location.pathname),
        additional = {},
        ...rumData
    } = rumError;

    if (!isRumAvailable()) {
        return;
    }

    const data = {
        ...rumData,
        level,
        page,
        additional: {
            query: window.location.search,
            ...additional,
        },
    };

    window.Ya.Rum.logError(data, error);
}
